"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseRestSvg = exports.CloseHoverSvg = exports.CloseButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireDefault(require("react"));
var _colors = require("../../../constants/colors");
var _spacing = require("../../../constants/spacing");
var _focusRing = require("../../../util/focusRing");
var _withFocusClassName = require("../../../util/withFocusClassName");
const CloseRestBase = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  d: "M17.091 8.606l-3.395 3.393 3.395 3.395-1.697 1.697L12 13.696l-3.393 3.395-1.697-1.697L10.302 12 6.91 8.606l1.697-1.697 3.393 3.393 3.395-3.393 1.697 1.697z"
}));
const CloseRestSvg = props => /*#__PURE__*/_react.default.createElement(_lodestarIcons.Icon, (0, _extends2.default)({
  svgComponent: CloseRestBase
}, props));
exports.CloseRestSvg = CloseRestSvg;
const CloseHoverBase = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 24 24",
  width: "24px",
  height: "24px",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "currentColor",
  d: "M 17.09 8.61 L 13.69 12 L 17.09 15.39 L 15.39 17.09 L 12 13.7 L 8.61 17.09 L 6.91 15.39 L 10.3 12 L 6.91 8.61 L 8.61 6.91 L 12 10.3 L 15.39 6.91 Z M 2 6 L 2 18 C 2 20.21 3.79 22 6 22 L 18 22 C 20.21 22 22 20.21 22 18 L 22 6 C 22 3.79 20.21 2 18 2 L 6 2 C 3.79 2 2 3.79 2 6 Z"
}));
const CloseHoverSvg = props => /*#__PURE__*/_react.default.createElement(_lodestarIcons.Icon, (0, _extends2.default)({
  svgComponent: CloseHoverBase
}, props));
exports.CloseHoverSvg = CloseHoverSvg;
function createFocusRing(_ref) {
  let {
    themeMode
  } = _ref;
  return (0, _focusRing.getFocusRingStyles)({
    theme: themeMode,
    includeFocusPseudoClass: true,
    offset: 5,
    radius: 4
  });
}
const CloseButton = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)("button")`
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
    height: 28px;
    padding-right: ${_spacing.sizes.xxSmall}px;
    color: inherit;

    // This doesn't do anything in Chrome because it's dealt with in the user-agent-stylesheet
    // But in every other browser it's necessary to vertically center the button.
    display: inline-flex;
    align-items: center;

    ${createFocusRing}

    &:hover .token--icon--hover {
        display: inline-block;
    }

    ${_ref2 => {
  let {
    isDisabled
  } = _ref2;
  return isDisabled ? `` : `&:hover .token--icon-rest {
                  display: none;
              }`;
}}

    ${_ref3 => {
  let {
    isDisabled
  } = _ref3;
  return isDisabled ? `color: ${_colors.neutral};` : "cursor: pointer;";
}}
`);
exports.CloseButton = CloseButton;
CloseButton.displayName = "CloseButton";
//# sourceMappingURL=CloseButton.js.map